import moment from "moment";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Author from "components/Table/Author";
import { Tooltip } from "@mui/material";

import Constants, { Icons, defaultData } from "utils/Constants";
import Pdf from "assets/images/pdf.svg";
import Frame from "assets/images/Frame.svg";
import { downloadFile, getFormattedCallingFirstName } from "utils/methods/methods";

const getActiveDocument = (documents = []) => {
  if (!Array.isArray(documents) || documents.length === 0) return null;
  return documents.find((doc) => doc.isActive) || documents[documents.length - 1];
};

export default function SafetyAlertData(
  alertList,
  handleEdit,
  handleDelete,
  handlePreview,
  handleViewAcknowledgements,
  permission
) {
  const rows =
    alertList?.map((item) => {
      const activeDocument = getActiveDocument(item.document);
      const uploadDate = activeDocument?.date || item.createdAt;
      const previewUrl = activeDocument?.url || "";

      return {
        document: (
          <MDBox display="flex" alignItems="center">
            <MDBox
              sx={{ cursor: "pointer" }}
              onClick={() => previewUrl && handlePreview(previewUrl)}
              display="flex"
            >
              <img
                src={previewUrl && previewUrl.includes(".pdf") ? Pdf : activeDocument?.url || Frame}
                alt="Preview"
                height="60px"
                width="60px"
                style={{
                  border: "1px solid #D0D5DD",
                  borderRadius: "8px",
                  marginTop: "5px",
                }}
              />
              <MDBox ml={1}>
                {activeDocument?.name &&
                activeDocument?.name?.length > defaultData.MEDIUM_CONTENT_LENGTH ? (
                  <MDTypography
                    display="block"
                    variant="caption"
                    sx={{ textTransform: "none", marginTop: "5px" }}
                  >
                    <Tooltip title={activeDocument?.name}>
                      <span>{`${activeDocument?.name.slice(
                        0,
                        defaultData.MEDIUM_CONTENT_LENGTH
                      )}...`}</span>
                    </Tooltip>
                  </MDTypography>
                ) : (
                  <MDTypography
                    display="block"
                    variant="caption"
                    sx={{ textTransform: "none", marginTop: "5px" }}
                  >
                    {activeDocument?.name}
                  </MDTypography>
                )}
                {uploadDate && (
                  <MDTypography display="block" variant="caption" color="text">
                    {`Upload Date: ${moment(uploadDate).format(defaultData.WEB_DATE_FORMAT)}`}
                  </MDTypography>
                )}
                {activeDocument?.version && (
                  <MDTypography display="block" variant="caption" color="text">
                    {`Version: ${activeDocument?.version}`}
                  </MDTypography>
                )}
              </MDBox>
            </MDBox>
          </MDBox>
        ),
        documentName: <Author name={item.title} style={{ textTransform: "none" }} />,
        documentNumber: <Author name={item.documentNumber} style={{ textTransform: "none" }} />,
        documentType: (
          <Author name={item.type.replace(/_/g, " ")} style={{ textTransform: "capitalize" }} />
        ),
        uploadedDate: (
          <Author
            name={
              uploadDate ? moment(uploadDate).format(defaultData.WEB_DATE_FORMAT) : Constants.NA
            }
          />
        ),
        uploadedBy: (
          <Author name={getFormattedCallingFirstName(item?.createdBy)} style={{}} align="left" />
        ),
        version: <Author name={activeDocument?.version || Constants.NA} />,
        action: (
          <MDBox>
            <Tooltip title="View Acknowledgements">
              <span>
                <MDBox component="span" onClick={() => handleViewAcknowledgements(item)}>
                  {Icons.VIEW}
                </MDBox>
              </span>
            </Tooltip>
            &nbsp;
            {permission?.update && (
              <>
                <Tooltip title="Edit">
                  <span>
                    <MDBox component="span" onClick={() => handleEdit(item)}>
                      {Icons.EDIT}
                    </MDBox>
                  </span>
                </Tooltip>
                &nbsp;
              </>
            )}
            {permission?.delete && (
              <>
                <Tooltip title="Delete">
                  <span>
                    <MDBox
                      component="span"
                      onClick={() => handleDelete(item[Constants.MONGOOSE_ID])}
                      sx={{ cursor: "pointer" }}
                    >
                      {Icons.DELETE}
                    </MDBox>
                  </span>
                </Tooltip>
                &nbsp;
              </>
            )}
            &nbsp;
            <Tooltip title="Download">
              <span>
                <MDBox
                  component="span"
                  sx={{ cursor: "pointer" }}
                  onClick={(event) =>
                    previewUrl &&
                    downloadFile(previewUrl, event, activeDocument?.name || item.title)
                  }
                >
                  {Icons.DOWNLOAD}
                </MDBox>
              </span>
            </Tooltip>
          </MDBox>
        ),
      };
    }) || [];

  return {
    safetyAlertColumns: [
      { Header: "Document Preview", accessor: "document", width: "18%", align: "left" },
      { Header: "Document Name", accessor: "documentName", width: "16%", align: "left" },
      { Header: "Document Number", accessor: "documentNumber", width: "12%", align: "left" },
      { Header: "Document Type", accessor: "documentType", width: "12%", align: "left" },
      { Header: "Uploaded Date", accessor: "uploadedDate", width: "12%", align: "left" },
      { Header: "Uploaded By", accessor: "uploadedBy", width: "12%", align: "left" },
      { Header: "Version", accessor: "version", width: "8%", align: "left" },
      { Header: "Action", accessor: "action", width: "10%", align: "center" },
    ],
    safetyAlertRows: rows,
  };
}
